import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/observable';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class NewsService {
  apiUrl = 'https://www.lejourporteconseil.com/ljpc-admin/wp-json/wp/v2';

  constructor(private http: HttpClient) { }

  getNews() {
    return this.http.get(`${this.apiUrl}/news?per_page=100`);
  }
  
  getActu(slug: string){
    return this.http.get(`${this.apiUrl}/news?slug=${slug}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/news/news.service.ts